import styled from 'styled-components';

import {
	EmptyStateWrapper,
	Wrapper as BindPanelWrapper,
} from '@dealstack/frontend/shared/components/FieldBinding/BindPanel/bindPanel.styled';
import { Wrapper as TemplateNameWrapper } from '@dealstack/frontend/shared/components/FieldBinding/TemplateNameField/templateNameField.styled';

/**
 * The one side panel, whichever job is showing.
 *
 * Bordered like the placement editor's was rather than bare like the binding editor's: the two
 * panels now share a box, and a border is what separates it from the canvas beside it.
 */
export const SidePanel = styled.div`
	display: flex;
	flex-direction: column;
	min-height: 0;
	height: 100%;
	border: 1px solid ${({ theme }) => theme.v3.colors.gray[2]};
	border-radius: 4px;
	overflow: hidden;

	/* The bind panel draws its own bordered, 12px-radius box. That is right where it is the only
	   thing on screen — the standalone binding editor's side panel is bare — but here THIS panel
	   is the box, so the nested one only added a second outline and a curved corner immediately
	   under the tab bar. Scoped to this panel so the standalone editor keeps its own. */
	${BindPanelWrapper},
	${EmptyStateWrapper} {
		border: none;
		border-radius: 0;
	}

	/* Same reason, plus a rule under it: the name sits above the tab bar, so without one the
	   two read as a single block. */
	${TemplateNameWrapper} {
		border: none;
		border-radius: 0;
		border-bottom: 1px solid ${({ theme }) => theme.v3.colors.gray[2]};
	}
`;

export const SidePanelHeader = styled.div`
	border-bottom: 1px solid ${({ theme }) => theme.v3.colors.gray[2]};
	padding: 0.75rem;
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	flex-shrink: 0;
`;

export const PanelScroller = styled.div`
	flex: 1;
	min-height: 0;
	overflow-y: auto;
	padding: 0.75rem;
`;

export const PanelFooter = styled.div`
	border-top: 1px solid ${({ theme }) => theme.v3.colors.gray[2]};
	padding: 0.75rem;
	display: flex;
	gap: 0.5rem;
	flex-shrink: 0;

	& > button {
		flex: 1;
		min-width: 0;
	}
`;
